import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AlignBg from "../AlignBg";
import WebDev from "../../Assets/Images/pexels-pixabay-276452.jpg";
import CompHard from "../../Assets/Images/gettyimages-937063796-612x612.jpg";
import INS from "../../Assets/Images/sec.jpg";
import RAA from "../../Assets/Images/raaooo.png";
import MamMdm from "../../Assets/Images/close-up-man-s-hand-using-his-mobile-phone.jpg";
import ItSupport from "../../Assets/Images/helpdesk.jpg";
import erp from "../../Assets/Images/gradient-erp-illustration_23-2149370943.jpg";
import { fadeUp, revealOnce } from "../motion";
import "../css/Services.css";

const SERVICES = [
  {
    img: INS,
    title: "Information & Network Security",
    text: "I safeguard your data and systems with robust cybersecurity solutions, protecting your business from cyber threats.",
    points: [
      "Comprehensive threat protection",
      "Data encryption & access control",
      "Incident response & recovery",
      "Security awareness training",
    ],
  },
  {
    img: erp,
    title: "Enterprise Resource Planning (ERP)",
    text: "Helping businesses manage and integrate their essential operations within a single, connected system.",
    points: [
      "Inventory management",
      "Customer relationship management",
      "Project management",
      "Accounting",
    ],
  },
  {
    img: ItSupport,
    title: "Information Technology Support",
    text: "Reliable IT support to troubleshoot issues, maintain smooth operations, and maximize your organization's productivity.",
    points: [
      "Minimize downtime",
      "Maximize user productivity",
      "Optimize technology utilization",
      "Enhance security",
    ],
  },
  {
    img: MamMdm,
    title: "Mobile Device & Application Management",
    text: "MDM/MAM solutions to secure and streamline your organization's mobile environment across every device.",
    points: [
      "Enhance security & compliance",
      "Maintain device control",
      "Optimize app management",
    ],
  },
  {
    img: WebDev,
    title: "Software Development & Maintenance",
    text: "I transform ideas into dynamic, interactive software with a seamless user experience to help your business thrive online.",
    points: ["Craft modern websites", "Maintain & enhance", "Evolve with technology"],
  },
  {
    img: CompHard,
    title: "Computer Hardware Solutions",
    text: "I help businesses and individuals with their hardware needs — from diagnosis and repair to upgrades and installations.",
    points: [
      "Enhance computer performance",
      "Ensure reliability",
      "Future-proof your infrastructure",
    ],
  },
  {
    img: RAA,
    title: "Research & Analysis",
    text: "Uncovering valuable insights through meticulous research and analysis to optimize strategies and enhance performance.",
    points: [
      "Targeted market research",
      "Business intelligence & reporting",
      "Cost-benefit analysis",
      "Competitive analysis",
    ],
  },
];

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="m5 13 4 4L19 7"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function Services() {
  return (
    <div>
      <AlignBg name="Services" title="Services" />
      <section className="section services-page">
        <div className="container services-page__list">
          {SERVICES.map((service, i) => (
            <motion.article
              key={service.title}
              className={`service-row ${i % 2 === 1 ? "is-reversed" : ""}`}
              variants={fadeUp}
              {...revealOnce}
            >
              <div className="service-row__media">
                <img src={service.img} alt={service.title} loading="lazy" />
              </div>
              <div className="service-row__body">
                <h2 className="service-row__title">{service.title}</h2>
                <p className="service-row__text">{service.text}</p>
                <ul className="service-row__points">
                  {service.points.map((point) => (
                    <li key={point}>
                      <span className="service-row__check">
                        <CheckIcon />
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
                <Link to="/Contact" className="btn btn-ghost">
                  Request this service →
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Services;
